(function () {
  var selector = '[data-rision-c-faq]';

  function init(root) {
    if (!root || root.getAttribute('data-rision-c-faq-ready') === 'true') return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-rision-c-faq-item]'));
    if (!items.length) return;

    root.setAttribute('data-rision-c-faq-ready', 'true');

    items.forEach(function (item) {
      var button = item.querySelector('[data-rision-c-faq-button]');
      if (!button) return;

      button.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        items.forEach(function (other) {
          var open = other === item && willOpen;
          other.classList.toggle('is-open', open);
          var otherButton = other.querySelector('[data-rision-c-faq-button]');
          if (otherButton) otherButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  function scan(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll(selector);
    Array.prototype.forEach.call(nodes, init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    scan(document);
  }
})();
